import PropTypes from 'prop-types';

export default function getter(state) {
  return {
    get(name = state.active) {
      const theme = state.themes[name];
      return { name, theme };
    },

    list() {
      return Object
        .keys(state.themes)
        .map(this.get.bind(this));
    },
  };
}

getter.stateTypes = {
  active: PropTypes.string.isRequired,
  themes: PropTypes.objectOf(PropTypes.object.isRequired).isRequired,
};
